<template>
  <div id="rubin-items-wrapper" class="relative min-h-full font-light tracking-wider">
    <!-- Brand fonts -->
    <fonts-rubin v-if="Config.getCatalogBrand() === 'R'"/>
    <fonts-steinberg v-else-if="Config.getCatalogBrand() === 'S'"/>

    <!-- Loading animation -->
    <AppLoading/>

    <!-- Main content -->
    <div v-if="getOwnRoute() === ''">
      <router-view></router-view>
    </div>
    <div v-else-if="getOwnRoute() === 'diamonds'">
      <diamonds-main/>
    </div>
    <div v-else-if="getOwnRoute() === 'catalog'">
      <catalog-main/>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppLoading from "./components/AppLoading.vue";
import DiamondsMain from "@/components/diamonds/diamondsMain.vue";
import CatalogMain from "@/components/catalog/catalogMain.vue";
import FontsRubin from "@/components/fonts/fontsRubin.vue";
import {Config} from "@/assets/ts/config";
import FontsSteinberg from "@/components/fonts/fontsSteinberg.vue";

const getOwnRoute = () => {
  const path = window.location.pathname

  if (Config.getCatalogItemType() !== "") {
    if (Config.getCatalogItemType() === "diamonds") {
      return "diamonds"
    } else {
      return "catalog"
    }
  } else if (Config.getInitialItem() != "") {
    return ""
  } else if (path.includes('/diamonds') || /\/diamonds\/(.*)/.test(path)) {
    return "diamonds"
  } else if (path.includes('/catalog') || /\/catalog\/(.*)/.test(path)) {
    return "catalog"
  }
  return ""
}
</script>

<style></style>
